<div class="body">
  <mat-toolbar class="toolbar">
    <div class="menu d-print-none">
      <button
        mat-icon-button
        class="noOutline"
        (click)="isExpanded = !isExpanded"
      >
        <mat-icon>menu</mat-icon>
      </button>
    </div>
    <div class="full-width">
      <div class="row full-width">
        <div class="col-sm-12 col-md-3 d-print-none d-flex align-items-center">
          <span class="toolbar-title">Users Catalog</span>
        </div>
        <div class="col-sm-12 col-md-7 d-flex">
          <div class="d-flex flex-column pl-5">
            <h1
              class="green mb-0"
              [ngClass]="{
                yellow: userCatalog?.pendingUser && (canCreate || canApprove),
                red: userCatalog?.details?.user?.status == 0
              }"
            >
              {{
                userCatalog?.details?.user?.name ??
                  (userCatalog ? "New User" : "")
              }}
            </h1>
            <span
              *ngIf="userCatalog?.pendingUser && (canCreate || canApprove)"
              class="status yellow"
            >
              (
              {{
                (userCatalog?.pendingUser?.statusName ?? "New") +
                  (userCatalog?.pendingUser?.actionName ? " - " : "") +
                  (userCatalog?.pendingUser?.actionName ?? "")
              }}
              )
            </span>
            <span *ngIf="userCatalog?.details?.user?.status == 0" class="red">
              (Inactive)
            </span>
          </div>
        </div>
        <div class="col-sm-12 col-md-2 d-flex justify-content-end">
          <mat-slide-toggle
            class="fs-8"
            [(ngModel)]="showModification"
            *ngIf="
              userCatalog?.pendingUser &&
              (canCreate || canApprove) &&
              userCatalog?.id
            "
          >
            Show Modification
          </mat-slide-toggle>
        </div>
      </div>
    </div>
  </mat-toolbar>
  <mat-sidenav-container class="sidenav-container" autosize>
    <mat-sidenav
      #sidenav
      class="builder-sidenav d-print-none"
      mode="side"
      opened="true"
      (mouseenter)="mouseenter()"
      (mouseleave)="mouseleave()"
    >
      <!-- Section 1 -->
      <mat-nav-list>
        <mat-list-item>
          <mat-icon
            matListItemIcon
            *ngIf="!isExpanded && !isShowing"
            class="blue"
            >search</mat-icon
          >
          <filter-box
            (changed)="applyFilter($event)"
            *ngIf="isExpanded || isShowing"
          ></filter-box>
        </mat-list-item>

        <!-- Table -->
        <mat-list-item style="height: unset">
          <div *ngIf="isExpanded || isShowing">
            <app-user-catalog-list
              (rowSelected)="rowSelected($event)"
              [filter]="filter"
            >
            </app-user-catalog-list>
          </div>
        </mat-list-item>
      </mat-nav-list>

      <!-- Section 2 -->
      <mat-nav-list id="left-nav-buttons">
        <mat-list-item (click)="create()" class="parent" *ngIf="canCreate">
          <span class="full-width" *ngIf="isExpanded || isShowing"
            >Create New</span
          >
          <mat-icon matListItemIcon class="yellow">add_box</mat-icon>
        </mat-list-item>
      </mat-nav-list>
    </mat-sidenav>

    <mat-sidenav-content>
      <div class="d-flex flex-column justify-content-between">
        <div class="sidenav-content">
          <user-catalog-details
            [userCatalog]="userCatalog"
            [showModification]="showModification"
            (saved)="refreshSaved($event)"
          >
          </user-catalog-details>
        </div>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>

  <!-- "loading">
    <!-- Copyright 2017 Google Inc. All Rights Reserved.
      Use of this source code is governed by an MIT-style license that
      can be found in the LICENSE file at http://angular.io/license -->
  <!-- </overlay-loading> -->
</div>
